import { render, staticRenderFns } from "./KnowledgeBaseExplorer.vue?vue&type=template&id=909ac908&"
import script from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports